<script setup lang="ts">
import { onBeforeMount, PropType, Ref, ref, watchEffect } from "vue";

const props = defineProps({
	modelValue: {
		type: Object as PropType<App.Data.Explorer.Filter.FilterValueDTO[]>,
		require: true,
	},
});

const emit = defineEmits(["update:modelValue"]);

onBeforeMount(() => {
	localModelValue.value = props.modelValue || [];
});

const emitChange = () => {
	emit("update:modelValue", localModelValue.value);
};

const localModelValue: Ref<App.Data.Explorer.Filter.FilterValueDTO[]> =
	ref(null);

// DO NOT touch the id's they are used as input for the query
const minutes = [...Array(60).keys()].map((minute) => {
	return {
		id: minute,
		level: null,
		selection_depth: null,
		model: null,
		label: minute.toString(),
	};
});

watchEffect(() => {
	console.log(localModelValue.value);
});
</script>

<template>
	<v-autocomplete
		placeholder="Select a Value"
		:items="minutes"
		item-title="label"
		item-value="id"
		multiple
		return-object
		:clearable="true"
		v-model="localModelValue"
		@update:modelValue="emitChange()"
	/>
</template>

<style lang="scss" scoped></style>
